import script from "./MalukuPrerenderSnapshot.vue?vue&type=script&setup=true&lang=js"
export * from "./MalukuPrerenderSnapshot.vue?vue&type=script&setup=true&lang=js"

import "./MalukuPrerenderSnapshot.vue?vue&type=style&index=0&id=59d85af2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d85af2"]])

export default __exports__